<template>
  <div>
    <b-row align-h="center" class=" carga">
      <b-col align-self="center" v-for="(items,key) in simulacros" :key="key" @click="goRouter('cargar-informacion',items.id_simulacro)" class="mx-auto report-list" lg="4">
        <p :class="items.nombre.length<15 ? 'mt-4': ''">{{items.nombre}}</p>
      </b-col>

    </b-row>
  </div>
</template>
<script>
export default {
  name: "select-report",
  props: {
    url: String
  },
  data: () => ({
    simulacros: ""
  }),
  created() {
    this.$store.dispatch("setModulo", "CARGA DE INFORMACIÓN");
    this.$store.dispatch("setNav", "active");

    this.$store.dispatch("getSimulacros").then(response => {
      this.simulacros = response.data.simulacro;
    });
  },
  methods: {
    goRouter(link, id) {
      localStorage.setItem("id_simulacro", id);
      this.$router.push({ name: link });
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["isAdmin"];
    }
  }
};
</script>
<style scoped>
</style>